export default "__VITE_ASSET__BQMG0w2I__"